import { change } from 'redux-form';
import {ApiHelper, axiosInstance } from '../../utils/ApiHelper'
import AnalyticsHelper from '../../utils/AnalyticsHelper'
import CloudEvent from '../../utils/CloudEvent'

export function save() {
  return (dispatch, getState) => {
    // const { active, customLine } = getState().account.businessLines
    const { persona } = getState().account.businessLines
    const { active, customLine } = getState().form.BusinessLines.values
    const custom = customLine.length>0 ? customLine : null
    const data = {
      "income_sources": [ custom, ...active ],
      persona
     }


    dispatch({type:'UPDATE_BUSINESS_LINES_REQUEST', data})

    return ApiHelper.updateUser(data)
    .then((json)=>{
      const user = json.data
      var properties = {}
      properties[CloudEvent.IncomeSources] = user.income_sources
      properties[CloudEvent.Persona] = user.persona[0]
      AnalyticsHelper.addPeopleProperty(user.token_id, properties)

      dispatch({type:'UPDATE_BUSINESS_LINES_SUCCESS', user})
      return user
    })
    // dispatch(actions.submitFields('businessLines', ApiHelper.updateUser(data)))
  }
}


export function savePersona() {
  return (dispatch, getState) => {
    const { persona } = getState().account.businessLines
    const data = {persona}

    dispatch({type:'UPDATE_PERSONA_REQUEST', data})

    return ApiHelper.updateUser(data)
    .then((json)=>{
      const user = json.data

      var properties = {}
      properties[CloudEvent.Persona] = user.persona[0]
      AnalyticsHelper.addPeopleProperty(user.token_id, properties)

      dispatch({type:'UPDATE_PERSONA_SUCCESS', user})
      return user
    })
  }
}

// export const addCustom = () => (dispatch) => dispatch(actions.push('businessLines', ""))
export const addCustom = () => (dispatch) => dispatch({type:'ADD_CUSTOM_BUSINESS_LINE'})


export const toggle = (line) => (dispatch) => dispatch({type:'TOGGLE_BUSINESS_LINE', line})

export const selectPersona = (persona, form) => (dispatch) => {
  // dispatch(change(form, 'persona', [persona]))
  dispatch({type:'TOGGLE_PERSONA', line: persona})
}



// WEBPACK FOOTER //
// ./src/account/business-lines/actions.js